import React from 'react';
import { withNamespaces } from 'react-i18next';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import DocumentHead from 'legacyComponents/documentHead';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { IssueTracker } from 'apps/issueTracker/app';
import { conf } from 'apps/project/config.yaml';

@withNamespaces()
@observer
export class IssuesPage extends React.Component {
  render() {
    const { projectManager, t } = this.props;
    const { project, issueTrackerAppManager } = projectManager;
    if (project && issueTrackerAppManager?.issueTracker) {
      return (
        <MainWrapper>
          <DocumentHead title={`${project?.name} | Issues`} />
          <IssueTracker
            title={t(conf.sections[3])}
            projectManager={projectManager}
            manager={issueTrackerAppManager}
          />
        </MainWrapper>
      );
    }
    return null;
  }
}

IssuesPage.propTypes = {
  params: PropTypes.object,
  repoManager: PropTypes.object,
  projectManager: PropTypes.object,
  t: PropTypes.func,
};
